"use strict";

class StationSettingsAdvancedInformationCtrl {

    constructor($rootScope, $http, $mdToast, $mdDialog, $scope)
    {
        this.$rootScope = $rootScope;

        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;

        this.settings = {};
        this.ptyList = [];
        this.station = {
            keywords: []
        };
        this.genreModel = {};

        this.fetch();

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;
        this.$rootScope.save = this.save.bind(this);

        $scope.$watch(() => {
            return $scope.informationform.$invalid;
        },(newVal) => {
            $rootScope.saveDisabled = newVal;
        });

    }

    fetch() {
        this.$http.get('/stationsettings/settings').then((response) => {
            this.settings = response.data;
        });

        if(this.ptyList.length <= 0) {
            this.$http.get('/ptycodes/').then((response) => {
                this.ptyList = response.data.details;
            });
        }


        this.$http.get('/station').then((response) => {
            if (!response.data.keywords) {
                response.data.keywords = [];
            }
            this.station = response.data;
            this.$http.get("/genres/" + this.station.genre_id).then((response) =>{
                this.genreModel = response.data;
            });
        });
    }

    save() {
        let data = this.settings;

        this.$http.put('/stationsettings/settings', data).then(() => {
            this.station["pty_code"] = Number(this.station["pty_code"]);
            return this.$http.put('/station', this.station).then(() => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.object_saved?object=Advanced_information',
                    hideDelay: 6000,
                    position: ('top right')
                });
            });
        });

    }

    genre(ev) {


        this.$mdDialog.show({

            controller: 'TreeControllerDialogCtrl',
            templateUrl: "genreDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true,

            locals: {

                genreModel: this.genreModel
            }

        }).then(($node) => {
            this.genreModel = $node;
            this.station.genre_id = $node.id;
        });
    };
}

StationSettingsAdvancedInformationCtrl.$inject = [
    '$rootScope',
    '$http',
    '$mdToast',
    '$mdDialog',
    '$scope'
];

module.exports = StationSettingsAdvancedInformationCtrl;